import React, { useContext, useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import LinkIcon from '@mui/icons-material/Link';
import Imagez from '../../lib/reusable/Imagez';
import Moviez from '../../lib/reusable/Moviez';
import axios from 'axios';
import { URI } from '../../core/config';

import { PlaceContext } from '../../core/contexts/PlaceContext';
import useEventsClick from './hooks/useEventClick';

import { useInViewLogger } from '../../core/hooks/useInViewLogger';

const StaticMovie = ({ onImageClick, event, type }) => {
  const {
    data: {
      place: { features },
    },
  } = useContext(PlaceContext);

  const viewRef = useInViewLogger({
    objectId: event.id,
    objectName: event.name,
    objectType: 'events',
    action: 'view',
    triggerInSeconds: 1.25,
    campaignId: event.campaignId,
    isActive: Boolean(features?.place?.logs),
  });

  return (
    <div ref={viewRef} className="WH100" onClick={onImageClick}>
      {type === 'url' && (
        <div className="p-abs p-top-right pt-4 mt-2 pr-8 l2" style={{ opacity: 0.75 }}>
          <LinkIcon className="txt-bread-crumb-trail s-24-i fds-2" />
        </div>
      )}
      <Moviez
        movie={event.src}
        rounded={false}
        dropShadow
        limitHeight={false}
        limitWidth={event?.spread?.configuration?.maxWidth}
      />
    </div>
  );
};

const StaticImage = ({ onImageClick, event, type }) => {
  const {
    data: {
      place: { features },
    },
  } = useContext(PlaceContext);

  const viewRef = useInViewLogger({
    objectId: event.id,
    objectName: event.name,
    objectType: 'events',
    action: 'view',
    triggerInSeconds: 1.25,
    campaignId: event.campaignId,
    isActive: Boolean(features?.place?.logs),
  });

  return (
    <div ref={viewRef} className="WH100" onClick={onImageClick}>
      {type === 'url' && (
        <div className="p-abs p-top-right pt-4 mt-2 pr-8 l2" style={{ opacity: 0.75 }}>
          <LinkIcon className="txt-bread-crumb-trail s-24-i fds-2" />
        </div>
      )}
      <Imagez image={event.src} dropShadow />
    </div>
  );
};

const SponsorEvents = () => {
  const {
    data: {
      place: { features },
    },
  } = useContext(PlaceContext);

  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (
      !Boolean(features?.sponsor?.active) ||
      features?.sponsor?.theme === undefined ||
      features?.sponsor?.theme === null
    ) {
      setEvents([]);
      return;
    }

    try {
      axios
        .get(`${URI.bucket}/__theming__/${features?.sponsor?.theme}/config.json?time=${Date.now()}`)
        .then((res) => {
          // Transform the events to match the expected structure
          const transformedEvents = res.data.events.map((event, index) => ({
            id: event.name || `event-${index}`,
            name: event.name,
            src: `${URI.bucket}${event.url}`,
            type: event.type,
            fileType: event.fileType,
            link: event.link,
            campaignId: event.campaignId || null,
          }));
          setEvents(transformedEvents);
        })
        .catch((err) => {
          setEvents([]);
        });
    } catch (error) {
      setEvents([]);
    }
  }, [features]);

  const handleClickUrl = (url) => {
    if (!url) return;
    window.open(url, '_blank');
  };

  if (events.length === 0) {
    return null;
  }

  return (
    <div className="p-rel f-c f-aic mt-8 mb-16">
      {events.map((event) => {
        const onImageClick = () => handleClickUrl(event?.link?.url);

        // Check if it's a video based on fileType
        if (event.fileType === 'mp4' && event.type === 'movie') {
          return (
            <Grid size={12} key={event.id}>
              <StaticMovie onImageClick={onImageClick} event={event} type={'url'} />
            </Grid>
          );
        }

        return (
          <Grid size={12} key={event.id}>
            <StaticImage onImageClick={onImageClick} event={event} type={'url'} />
          </Grid>
        );
      })}
    </div>
  );
};

export default SponsorEvents;
